/**
 * pinia-plugin-persist-uni 通用 storage 适配
 *
 * 各 store 共享同一份实现,避免在每个文件里手写 getItem/setItem
 */
export const uniStorage = {
  getItem: (key) => uni.getStorageSync(key),
  setItem: (key, value) => uni.setStorageSync(key, value),
  removeItem: (key) => uni.removeStorageSync(key),
}

/**
 * 生成单 key 持久化配置
 *
 * @param {string} key 存储键
 * @param {string[]=} paths 仅持久化指定字段,缺省时持久化整个 state
 */
export const persistOptions = (key, paths) => ({
  enabled: true,
  strategies: [
    {
      key,
      storage: uniStorage,
      ...(paths ? { paths } : {}),
    },
  ],
})
